import React, { useState } from 'react';
import './newfolderpopup.css';
import { ClientService } from '../../../../../services/clientService';
import { ClientFolderService } from '../../../../../services/clientFolderService';
const NewFolderPopup = ({
  isNewFolderPopupVisible,
  closeNewFolderPopup,
  handleCreateFolder,
  newFolderName,
  setNewFolderName,
  clientId,
  setSelectedFolder,
  isCurated = false,
  shortlistNote
}) => {
  const [errorMessage, setErrorMessage] = useState('');

  const handleCreateFolderClick = async () => {
    if (!newFolderName.trim()) {
      setErrorMessage('Folder name is required');
      return;
    }

    try {
      const response = await ClientFolderService.createFolder(
        clientId,
        newFolderName.trim()
      );

      const createdFolder = response?.data;

      setSelectedFolder?.({
        ...createdFolder,
        note: shortlistNote,
      });
      setNewFolderName('');
      setErrorMessage('');

      let foldersResponse;
      if (isCurated) {
        foldersResponse = await ClientFolderService.listCuratedFolders(clientId);
      } else {
        foldersResponse = await ClientFolderService.listShortlistedFolders(clientId);
      }

      if (typeof handleCreateFolder === 'function') {
        handleCreateFolder(foldersResponse.data);
      }
    } catch (error) {
      console.error('Create folder error:', error);

      if (
        error?.response?.status === 409 ||
        error?.response?.data?.message?.toLowerCase().includes('exists')
      ) {
        setErrorMessage('Folder name already exists.');
      } else {
        setErrorMessage('Something went wrong. Please try again.');
      }
    }
  };

  return isNewFolderPopupVisible ? (
    <div className="new-folder-popup-overlay position-fixed top-0 start-0 d-flex justify-content-center align-items-center bg-dark bg-opacity-50">
      <div className="new-folder-popup-container bg-white p-4 rounded">
        <div className="new-folder-popup-header text-center mb-4">
          <h2>Create New Folder</h2>
        </div>
        <div className="new-folder-popup-content">
          <div className="new-folder-popup-folder-name mb-4">
            <label>Folder Name *</label>
            <input
              type="text"
              placeholder="Enter folder name"
              className="new-folder-form-control"
              value={newFolderName}
              spellCheck="false"
              onChange={(e) => {
                setNewFolderName(e.target.value);
                setErrorMessage('');
              }}
            />
            {errorMessage && <p className="text-danger">{errorMessage}</p>}          </div>
        </div>
        <div className="profile-new-folder-popup-actions">
          <button type="button" className="new-folder-popup-cancel" onClick={closeNewFolderPopup}>
            Cancel
          </button>
          <button type="button" className="new-folder-popup-create" onClick={handleCreateFolderClick}>
            Create
          </button>
        </div>
      </div>
    </div>
  ) : null;
};

export default NewFolderPopup;
